// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1IVh3","col":"styles_col__3qt_w"};